module.exports = __webpack_public_path__ + "media/assets/images/play-button-2e7cd2c1dea81e787a2986bed7c0f922.svg";